 <template>
  <div>
    <div class="top-div">
      <div @click="handleBack" style="font-size: 22px;margin: 5px 10px 0 0;">
        <van-icon name="arrow-left" />
      </div>
      <div class="top-div-title">内容库</div>
    </div>
    <van-tabs v-model="active" color="#8f8ee6" title-active-color="#8f8ee6" @change="change">
      <van-tab title="文章">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==0" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="海报">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==1" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @keyword="getkeyword">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="表单">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==2" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="文件">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtFileLoad">
          <contents v-if="active==3" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="视频">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==4" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="图集">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==5" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
      <van-tab title="外部链接">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="CtListLoad">
          <contents v-if="active==6" :name='name' :filterList='list' :titleIndex="titleIndex" :sessionId="sessionId" @type="getType"
            @groupId="getGroupId" @keyword="getkeyword" @getDeptId="getDeptId">
          </contents>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import contents from "../iM/components/contents"
import ppt from '../../assets/images/ppt.png'
import world from '../../assets/images/world.png'
import excel from '../../assets/images/excel.png'
import pdf from '../../assets/images/pdf.png'
import txtIcon from '../../assets/images/txtIcon.png'
import zipIcon from '../../assets/images/zipIcon.png'
import unknowFileIcon from '../../assets/images/unknowFileIcon.png'

export default {
  components: {
    contents,
  },
  data () {
    return {
      type: 2,
      active: 0,
      name: '文章',
      titleIndex: 0,
      isQueryType: null,
      contactId: null,
      sessionId: null,
      accountId: null,
      memo: '',
      accountName: '',
      page: 0,
      pageCount: 10,
      list: [],
      keyword: '',
      groupId: '',
      isLoading: false,
      loading: false,
      finished: false,
      deptId: null,
    }
  },
  created () {
    this.page = 0

    let { type, contactId, sessionId, accountId, memo, name } = this.$route.query
    this.isQueryType = type
    this.contactId = contactId
    this.sessionId = sessionId
    this.accountId = accountId
    this.memo = memo
    this.accountName = name
  },
  methods: {
    // 获取type 2企业1个人
    getType (val) {
      this.type = Number(val)
      if (this.name === '海报') {
        this.getMsg()
      }
    },
    // 获取分组id groupId
    getGroupId (val) {
      this.groupId = val
      this.getMsg()
    },
    getDeptId (val) {
      this.deptId = val
      this.groupId = null // 先清空缓存，再由getGroupId赋值
      this.getMsg()
    },
    getMsg () {
      if (this.groupId !== null) {
        this.page = 1
        this.loading = true
        this.finished = false
        this.list = []
        if (this.type === 1 || this.type === 2) {
          this.deptId = null
        }
        if (this.name === '文件') {
          this.CtFile(false)
        } else {
          this.CtDetailList(this.name, false)
        }
      }
    },
    // 获取keyword
    getkeyword (val) {
      this.keyword = val
      console.log(val, this.keyword, 'keyword');
      this.getMsg()
    },
    // tab切换
    change (val, name) {
      this.keyword = ''
      this.active = val
      this.name = name
      this.type = 2
      if (this.name === '海报') {
        this.getMsg()
      }
    },
    handleChange () {
      this.getMsg()
    },
    CtFileLoad () {
      if (this.list.length > 0) {
        this.finished = false
        this.loading = true
        this.CtFile(true)
      }
    },
    CtListLoad () {
      if (this.list.length > 0) {
        this.finished = false
        this.loading = true
        this.CtDetailList(this.name, true)
      }
    },
    async CtDetailList (name, load) {
      if (load) {
        this.page++
      }
      let url,
        params;

      params = {
        owner: this.type,
        page: this.page,
        pageCount: this.pageCount,
        groupId: this.groupId,
        name: this.keyword,
        deptId: this.deptId
      }
      if (name === '文章') {
        this.titleIndex = 0
        url = '/scrm/v1/ct-article/m/findSimpleListByPage'
      } else if (name === '海报') {
        if (this.type === 2) {
          params = {
            owner: 2,
            corporate: 1,
            name: this.keyword,
            page: this.page,
            pageCount: this.pageCount
          }
          url = '/scrm/v1/ct-poster-src/m/findListByPage'
          this.titleIndex = 31
        } else {
          url = '/scrm/v1/ct-poster/m/findListByPage'
          this.titleIndex = 1
        }
      } else if (name === '表单') {
        url = '/scrm/v1/ct-form/m/findListByPage'
        this.titleIndex = 2
      } else if (name === '视频') {
        url = '/scrm/v1/ct-video/m/findListByPage'
        this.titleIndex = 15
      }
       else if (name === '图集') {
        url = '/scrm/v1/ct-img/m/findListByPage'
        this.titleIndex = 17
      }
       else if (name === '外部链接') {
        url = '/scrm/v1/ct-url/m/findListByPage'
        this.titleIndex = 4
      }

      let res = await this.$http.get(url, { params })

      if (res.code === 1) {
        if (res.data === null) {
          res.data = {}
          res.data.records = []
        }

        if (res.data.records.length !== 0) {
          this.list.push(...res.data.records)
          this.loading = false
          this.isLoading = false
        } else {
          //  this.List=[]
          this.finished = true
        }
        if (this.list.length >= res.total) {
          this.finished = true;	// 结束加载状态
        }
      }
    },
    // 文件
    CtFile (load) {
      if (load) {
        this.page++
      }
      this.$http.get('/scrm/v1/ct-file/m/findListByPage', {
        params: {
          owner: this.type,
          page: this.page,
          pageCount: this.pageCount,
          groupId: this.groupId,
          name: this.keyword,
          deptId: this.deptId
        }
      }).then(res => {
        if (res.code === 1) {
          if (res.data.records.length !== 0) {
            res.data.records.map(item => {
              let suffix = item.name.substring(item.name.lastIndexOf('.') + 1).toLowerCase()
              if (suffix === 'xls' || suffix === 'xlsx') {
                item.cover = excel
              } else if (suffix === 'doc' || suffix === 'docx') {
                item.cover = world
              } else if (suffix === 'ppt' || suffix === 'pptx') {
                item.cover = ppt
              } else if (suffix === 'rar' || suffix === 'gzip' || suffix === 'zip' || suffix === 'arj' ||
                suffix === 'tar' || suffix === '7z') {
                item.cover = zipIcon
              } else if (suffix === 'txt') {
                item.cover = txtIcon
              } else if (suffix === 'pdf') {
                item.cover = pdf
              } else {
                item.cover = unknowFileIcon
              }
              return item
            })
            this.list.push(...res.data.records)
            console.log(this.list)
            this.loading = false
            this.isLoading = false
          } else {
            //  this.List=[]
            this.finished = true
          }
          if (this.list.length >= res.total) {
            this.finished = true;		// 结束加载状态
          }
        }
      })
    },
    // 返回
    handleBack () {
      //   this.$router.go(-1)
      this.$router.push({ path: '/chatIndex', query: { type: this.isQueryType, contactId: this.contactId, sessionId: this.sessionId, accountId: this.accountId, memo: this.memo, name: this.accountName } })
    },
  },
}
</script>
<style lang="less" scoped>
.top-div {
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 0 0 12px;
  background-color: #3974c4;
  > div {
    line-height: 50px;
    font-size: 18px;
    color: #fff;
  }
}
</style>
